var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _g, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPm014Nodata(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 389,
    viewBox: "0 0 435 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.064 317.877L169.115 207.919H287.728L434 304.716",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.064 317.877L169.115 207.919H287.728L434 304.716",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.921 313.547L169.115 215.253V207.919L221.186 323L205.921 313.547Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236.931 212.468L287.383 271.799L226.142 286.111L191.345 219.791L236.931 212.468Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.143 286.111V287.861L286.338 275.644L287.383 271.799L226.143 286.111Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.026 233.815L237.609 237.637L244.173 235.853L241.442 232.122L235.026 233.815Z",
    fill: "#666666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M259.873 257.202L256.751 252.965L249.291 254.98L252.206 259.309L259.873 257.202Z",
    fill: "#666666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M229.669 225.85L231.586 228.705L237.76 227.128L235.821 224.479L229.669 225.85Z",
    fill: "#666666"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M241.557 243.501L245.091 248.751L252.31 246.92L248.408 241.612L241.557 243.501Z",
    fill: "#666666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M260.252 245.965L254.066 247.542L257.165 251.756L263.466 250.052L260.252 245.965Z",
    fill: "#666666"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M245.72 249.671L248.669 254.069L256.083 252.055L252.973 247.817L245.72 249.671Z",
    fill: "#666666"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M222.678 227.401L224.583 230.487L230.505 228.967L228.565 226.089L222.678 227.401Z",
    fill: "#666666"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M238.217 238.548L240.948 242.59L247.743 240.701L244.839 236.752L238.217 238.548Z",
    fill: "#666666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M232.203 229.615L234.407 232.897L240.765 231.216L238.424 228.026L232.203 229.615Z",
    fill: "#666666"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M218.84 237.015L216.912 233.526L209.877 235.323L211.839 238.869L218.84 237.015Z",
    fill: "#666666"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M208.735 245.457L213.567 244.156L211.329 240.104L206.577 241.359L208.735 245.457Z",
    fill: "#666666"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M220.586 224.02L222.089 226.461L227.931 225.16L226.359 222.834L220.586 224.02Z",
    fill: "#666666"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M216.389 232.571L214.53 229.209L207.38 230.786L209.354 234.367L216.389 232.571Z",
    fill: "#666666"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M213.645 225.435L215.068 228.014L221.013 226.701L219.486 224.237L213.645 225.435Z",
    fill: "#666666"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M203.648 235.832L208.307 234.634L206.31 231.03L201.662 232.055L203.648 235.832Z",
    fill: "#666666"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M205.358 227.137L206.85 229.831L214 228.254L212.566 225.651L205.358 227.137Z",
    fill: "#666666"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M227.819 235.729L230.229 239.632L236.542 237.928L233.959 234.105L227.819 235.729Z",
    fill: "#666666"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M244.023 249.024L240.5 243.797L233.924 245.616L237.114 250.786L244.023 249.024Z",
    fill: "#666666"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M215.596 228.969L217.432 232.308L223.515 230.753L221.598 227.645L215.596 228.969Z",
    fill: "#666666"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M216.973 250.303L212.015 251.673L214.585 256.543L219.693 255.242L216.973 250.303Z",
    fill: "#666666"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M230.803 240.562L233.351 244.684L239.881 242.888L237.161 238.835L230.803 240.562Z",
    fill: "#666666"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M226.192 235.081L224.092 231.685L217.963 233.25L219.891 236.751L226.192 235.081Z",
    fill: "#666666"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M237.7 271.181L230.688 272.977L233.189 277.502L240.225 275.763L237.7 271.181Z",
    fill: "#666666"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M226.844 221.671L232.847 220.439L229.622 216.041L223.711 217.02L226.844 221.671Z",
    fill: "#666666"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M212.038 224.699L209.134 219.438L201.777 220.658L204.83 226.185L212.038 224.699Z",
    fill: "#666666"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M221.586 241.978L219.371 237.96L212.37 239.814L214.608 243.867L221.586 241.978Z",
    fill: "#666666"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M239.457 256.57L236.633 251.999L229.334 253.864L231.951 258.608L239.457 256.57Z",
    fill: "#666666"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M236.058 251.063L232.868 245.905L225.993 247.805L228.805 252.906L236.058 251.063Z",
    fill: "#666666"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M247.605 254.355L244.644 249.945L237.689 251.718L240.513 256.278L247.605 254.355Z",
    fill: "#666666"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M229.174 239.917L226.763 236.002L220.405 237.694L222.62 241.69L229.174 239.917Z",
    fill: "#666666"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M225.155 231.42L227.244 234.794L233.338 233.182L231.123 229.889L225.155 231.42Z",
    fill: "#666666"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M232.292 244.986L229.744 240.853L223.134 242.637L225.475 246.874L232.292 244.986Z",
    fill: "#666666"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M251.151 259.609L248.225 255.279L241.086 257.214L243.806 261.623L251.151 259.609Z",
    fill: "#666666"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M246.433 267.864L243.323 262.832L235.473 264.997L238.227 269.959L246.433 267.864Z",
    fill: "#666666"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M222.905 261.056L220.219 256.186L215.089 257.498L217.706 262.472L222.905 261.056Z",
    fill: "#666666"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M214.091 245.1L209.236 246.412L211.52 250.73L216.444 249.371L214.091 245.1Z",
    fill: "#666666"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M237.174 270.235L234.442 265.272L227.487 267.184L230.161 272.02L237.174 270.235Z",
    fill: "#666666"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M224.431 247.151L222.101 242.926L215.123 244.814L217.487 249.086L224.431 247.151Z",
    fill: "#666666"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M227.474 222.603L229.034 224.917L235.14 223.559L233.522 221.359L227.474 222.603Z",
    fill: "#666666"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M201.155 231.099L205.78 230.075L204.288 227.357L199.675 228.302L201.155 231.099Z",
    fill: "#666666"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M219.992 223.064L225.73 221.889L222.574 217.203L216.95 218.136L219.992 223.064Z",
    fill: "#666666"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M213.116 224.48L218.912 223.294L215.836 218.32L210.224 219.253L213.116 224.48Z",
    fill: "#666666"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M210.811 239.159L208.837 235.59L204.154 236.787L206.071 240.403L210.811 239.159Z",
    fill: "#666666"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M233.97 220.208L239.157 219.137L235.898 215.004L230.768 215.844L233.97 220.208Z",
    fill: "#666666"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M203.75 226.404L200.674 220.831L196.129 221.591L199.17 227.336L203.75 226.404Z",
    fill: "#666666"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M229.647 273.238L224.138 274.643L226.525 279.156L232.148 277.763L229.647 273.238Z",
    fill: "#666666"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M255.821 266.541L248.062 268.521L250.897 273.115L258.908 271.124L255.821 266.541Z",
    fill: "#666666"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M247.006 268.795L238.743 270.902L241.28 275.496L249.83 273.377L247.006 268.795Z",
    fill: "#666666"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M265.003 264.191L256.9 266.264L259.988 270.858L268.377 268.774L265.003 264.191Z",
    fill: "#666666"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M272.98 262.153L266.094 263.915L269.479 268.509L276.595 266.736L272.98 262.153Z",
    fill: "#666666"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M226.455 267.472L221.118 268.934L223.632 273.701L229.118 272.296L226.455 267.472Z",
    fill: "#666666"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M242.75 261.908L240.03 257.498L232.479 259.548L234.958 264.049L242.75 261.908Z",
    fill: "#666666"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M255.203 265.618L251.759 260.518L244.38 262.544L247.49 267.587L255.203 265.618Z",
    fill: "#666666"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M233.926 264.33L231.435 259.828L224.469 261.728L226.971 266.241L233.926 264.33Z",
    fill: "#666666"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M220.624 267.989L225.938 266.527L223.436 262.002L218.214 263.418L220.624 267.989Z",
    fill: "#666666"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M227.763 253.183L224.963 248.094L218.008 250.017L220.739 254.968L227.763 253.183Z",
    fill: "#666666"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M264.338 263.282L260.54 258.112L252.827 260.231L256.282 265.343L264.338 263.282Z",
    fill: "#666666"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M230.916 258.882L228.287 254.127L221.264 255.923L223.949 260.782L230.916 258.882Z",
    fill: "#666666"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M249.487 241.312L253.401 246.632L259.541 245.066L255.318 239.7L249.487 241.312Z",
    fill: "#666666"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M241.856 230.928L247.296 229.489L244.852 226.392L239.526 227.75L241.856 230.928Z",
    fill: "#666666"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M236.942 224.234L238.848 226.836L244.15 225.489L242.233 223.06L236.942 224.234Z",
    fill: "#666666"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M272.271 261.252L268.162 256.014L261.62 257.81L265.43 263.003L272.271 261.252Z",
    fill: "#666666"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M242.52 231.837L245.262 235.556L250.863 234.037L247.994 230.387L242.52 231.837Z",
    fill: "#666666"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M257.828 252.663L260.95 256.911L267.457 255.127L264.163 250.947L257.828 252.663Z",
    fill: "#666666"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M236.255 223.314L241.523 222.151L239.882 220.056L234.66 221.126L236.255 223.314Z",
    fill: "#666666"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M248.823 240.416L254.619 238.804L251.577 234.936L245.931 236.467L248.823 240.416Z",
    fill: "#666666"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M295.383 219.1V228.518C294.429 229.443 293.379 230.261 292.25 230.959C290.517 232.007 276.251 234.413 276.251 234.413L294.338 254.321C294.338 254.321 310.922 252.501 315.571 251.177C320.437 249.773 319.392 231.972 319.392 231.972L295.383 219.1Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M295.383 219.1V228.518C295.383 228.518 295.131 228.771 294.718 229.14L315.87 251.085C320.391 249.047 319.393 232.007 319.393 232.007L295.383 219.1Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M263.375 98.666V198.503L339.225 258.536V104.25L263.375 98.666Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M268.597 103.904V188.025L332.27 227.471V109.489L268.597 103.904Z",
    fill: "#605BFF",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M346.878 104.252H339.223V258.573H346.878V104.252Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M272.774 109.143L273.119 184.19L326.348 214.552V121.624L289.817 116.074L287.384 110.881L272.774 109.143Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M276.251 118.215V182.094L323.226 207.229V126.597L276.251 118.215Z",
    fill: "#605BFF",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M303.724 180.565C310.352 178.333 313.239 169.095 310.172 159.932C307.105 150.769 299.246 145.151 292.619 147.383C285.991 149.616 283.104 158.854 286.171 168.017C289.237 177.18 297.096 182.798 303.724 180.565Z",
    fill: "#666666"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M299.559 165.022L304.023 160.059C304.324 159.617 304.479 159.091 304.464 158.555C304.45 158.02 304.267 157.503 303.943 157.077C303.277 156.122 302.233 155.926 301.648 156.605L297.355 161.383L293.051 154.475C292.432 153.473 291.387 153.163 290.756 153.784C290.423 154.197 290.234 154.707 290.218 155.237C290.201 155.767 290.358 156.288 290.664 156.72L295.129 163.917L290.584 168.856C290.283 169.299 290.129 169.826 290.146 170.362C290.162 170.898 290.348 171.415 290.676 171.838C290.938 172.255 291.348 172.555 291.823 172.679C292.03 172.73 292.247 172.723 292.449 172.658C292.652 172.593 292.833 172.472 292.971 172.31L297.275 167.532L301.567 174.44C301.831 174.91 302.268 175.257 302.784 175.407C302.982 175.47 303.194 175.477 303.396 175.429C303.598 175.38 303.783 175.277 303.931 175.131C304.261 174.717 304.447 174.206 304.461 173.677C304.476 173.147 304.318 172.627 304.012 172.195L299.559 165.022Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M284.597 139.862L310.902 147.611",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M283.549 132.531L317.646 142.076",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M307.054 297.017C307.054 297.017 290.425 298.56 284.273 303.5C278.121 308.439 282.735 310.915 288.577 312.457C294.418 314 320.597 311.525 323.983 308.128C327.368 304.732 323.983 296.396 307.054 297.017Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M323.985 308.171C324.639 307.516 325.045 306.653 325.133 305.73C317.685 305.362 307.918 307.527 299.046 310.336C296.051 311.292 293.01 312.095 289.934 312.742C297.669 313.675 320.818 311.303 323.985 308.171Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M248.098 113.771L260.252 120.116",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M241.121 110.134L244.736 112.023",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M250.771 145.734L254.892 146.207",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M235.001 143.903L246.111 145.193",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M253.368 175.383L239.596 179.217",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M235.589 6.51172C229.074 6.51172 222.706 8.44977 217.289 12.0808C211.873 15.7118 207.651 20.8727 205.158 26.9109C202.665 32.949 202.012 39.5933 203.283 46.0033C204.554 52.4134 207.691 58.3015 212.298 62.9229C216.904 67.5443 222.773 70.6915 229.163 71.9666C235.552 73.2416 242.175 72.5872 248.194 70.0861C254.213 67.585 259.357 63.3496 262.976 57.9154C266.596 52.4812 268.527 46.0923 268.527 39.5566C268.527 30.7926 265.057 22.3875 258.88 16.1903C252.703 9.99322 244.325 6.51172 235.589 6.51172ZM235.589 66.1077C230.355 66.1054 225.239 64.5463 220.889 61.6274C216.538 58.7086 213.147 54.561 211.146 49.7093C209.145 44.8575 208.622 39.5193 209.645 34.3697C210.667 29.2201 213.189 24.4902 216.89 20.7781C220.592 17.066 225.308 14.5384 230.441 13.5149C235.575 12.4913 240.896 13.0178 245.731 15.0277C250.566 17.0377 254.699 20.4408 257.606 24.8068C260.514 29.1729 262.066 34.3058 262.066 39.5566C262.072 43.0476 261.391 46.5056 260.063 49.7323C258.735 52.9591 256.785 55.8912 254.326 58.3608C251.866 60.8304 248.945 62.789 245.73 64.1242C242.515 65.4595 239.069 66.1452 235.589 66.1422V66.1077Z",
    fill: "#666666"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M237.942 39.5899C237.954 40.059 237.825 40.5209 237.574 40.9165C237.322 41.3122 236.959 41.6237 236.53 41.8112C236.101 41.9987 235.627 42.0537 235.167 41.9693C234.706 41.8848 234.282 41.6647 233.947 41.337C233.612 41.0093 233.382 40.5889 233.287 40.1295C233.191 39.6702 233.234 39.1927 233.411 38.758C233.587 38.3233 233.888 37.9513 234.276 37.6893C234.664 37.4273 235.122 37.2872 235.589 37.2871C236.204 37.2869 236.793 37.5277 237.233 37.958C237.673 38.3883 237.927 38.9739 237.942 39.5899Z",
    fill: "#666666"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M227.704 51.5778L235.589 39.5918L248.913 50.6567",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7974 64.9219L56.8379 54.0643L58.9496 56.4477V52.7402L63.4371 59.6256L59.4776 34.9973L64.7569 48.5031L65.2848 36.5862L66.0767 40.5585L67.1326 27.0527L68.9804 47.7087L71.62 40.5585L71.0921 49.8272L78.2192 28.6417L74.7876 55.1236L79.803 51.4161L76.8994 56.1829L80.5949 53.5347L76.3829 65.7164L61.0614 65.9812",
    fill: "#605BFF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M77.734 91.6682H61.2304L56.7773 62.9756H82.1755L77.734 91.6682Z",
    fill: "#666666",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M122.919 91.4717H39.6084V313.817H122.919V91.4717Z",
    fill: "white",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M117.252 98.7725H44.4541V152.324H117.252V98.7725Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4087 120.682H66.292V130.422H95.4087V120.682Z",
    fill: "#666666"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M117.252 161.259H44.4541V214.81H117.252V161.259Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4087 183.168H66.292V192.909H95.4087V183.168Z",
    fill: "#666666"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M117.252 223.735H44.4541V277.287H117.252V223.735Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4087 245.645H66.292V255.385H95.4087V245.645Z",
    fill: "#666666"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M131.852 301.124C131.852 301.124 173.604 282.621 196.053 281.228L212.43 317.531H88.7334L131.852 301.124Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M182.67 82.3818C182.67 82.3818 212.062 117.407 218.248 123.832C224.434 130.257 224.664 134.92 222.667 137.798C220.67 140.677 205.658 146.008 190.187 155.979C174.717 165.95 130.738 191.672 130.301 192.57C129.865 193.468 125.653 161.482 125.653 161.482L199.243 131.109L199.025 128.886L175.153 84.5465L182.67 82.3818Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M210.958 134.083L176.849 84.1123L175.208 84.5959L199.079 128.936L199.297 131.158L125.708 161.532C125.708 161.532 125.788 162.084 125.903 163.017L130.7 174.059L210.958 134.083Z",
    fill: "#605BFF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M210.958 134.083L176.849 84.1123L175.208 84.5959L199.079 128.936L199.297 131.158L125.708 161.532C125.708 161.532 125.788 162.084 125.903 163.017L130.7 174.059L210.958 134.083Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M182.67 82.3818C182.67 82.3818 212.062 117.407 218.248 123.832C224.434 130.257 224.664 134.92 222.667 137.798C220.67 140.677 205.658 146.008 190.187 155.979C174.717 165.95 130.738 191.672 130.301 192.57C129.865 193.468 125.653 161.482 125.653 161.482L199.243 131.109L199.025 128.886L175.153 84.5465L182.67 82.3818Z",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M159.247 67.0828C159.247 67.0828 155.712 63.9741 153.944 67.0828C152.177 70.1916 151.959 75.2807 153.061 75.7298C154.162 76.1788 158.581 75.511 159.247 74.1754C159.912 72.8398 159.247 67.0828 159.247 67.0828Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M165.432 65.5285C165.432 65.5285 161.679 61.5447 159.246 63.0876C156.813 64.6304 157.478 73.0701 158.362 73.7379C159.246 74.4057 164.548 72.5865 165.248 71.5157C165.948 70.445 165.432 65.5285 165.432 65.5285Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M173.831 65.7472C173.831 65.7472 170.514 61.1416 167.427 61.1416C164.34 61.1416 162.113 72.2295 163.227 73.1161C164.34 74.0026 171.616 72.8973 172.064 72.2295C172.772 70.1033 173.362 67.9392 173.831 65.7472Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M180.292 73.2875C180.292 71.9634 179.638 60.4265 175.702 61.0943C171.765 61.7621 167.53 71.0768 167.748 72.6082C167.966 74.1395 180.292 73.2875 180.292 73.2875Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M199.239 131.156C199.239 131.156 210.51 135.37 214.71 135.14L199.239 131.156Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M199.239 131.156C199.239 131.156 210.51 135.37 214.71 135.14",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M106.564 317.829C118.569 315.803 133.948 307.524 138.527 297.104C135.084 279.039 130.734 253.593 130.734 238.027C130.734 211.867 137.621 197.014 134.487 179.306C131.354 161.597 124.767 150.049 117.697 145.386C117.697 145.386 106.874 148.264 95.822 158.684C84.7698 169.104 75.049 187.02 71.2616 204.095C67.4743 221.17 62.4245 273.708 62.4245 287.456C62.4245 301.203 61.4375 318.267 61.4375 318.267C74.6703 318.267 87.903 318.267 101.136 318.267C102.955 318.284 104.772 318.138 106.564 317.829Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M138.527 297.096C131.802 302.853 101.515 314.033 97.0959 315.023C92.6774 316.013 95.1334 306.641 102.008 297.28C108.883 287.919 93.6529 300.734 91.1969 301.713C88.7408 302.692 92.1839 283.475 92.1839 274.079C92.1839 264.684 101.032 184.87 101.032 184.87L117.731 154.3L123.47 150.846C121.867 148.709 119.929 146.846 117.731 145.331C117.731 145.331 106.909 148.21 95.8564 158.63C84.8043 169.05 75.049 187.023 71.2616 204.098C67.4743 221.173 62.4245 273.711 62.4245 287.459C62.4245 301.206 61.4375 318.27 61.4375 318.27C74.6703 318.27 87.903 318.27 101.136 318.27C102.948 318.271 104.758 318.109 106.541 317.786C118.569 315.806 133.948 307.527 138.527 297.096Z",
    fill: "#605BFF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M138.527 297.096C131.802 302.853 101.515 314.033 97.0959 315.023C92.6774 316.013 95.1334 306.641 102.008 297.28C108.883 287.919 93.6529 300.734 91.1969 301.713C88.7408 302.692 92.1839 283.475 92.1839 274.079C92.1839 264.684 101.032 184.87 101.032 184.87L117.731 154.3L123.47 150.846C121.867 148.709 119.929 146.846 117.731 145.331C117.731 145.331 106.909 148.21 95.8564 158.63C84.8043 169.05 75.049 187.023 71.2616 204.098C67.4743 221.173 62.4245 273.711 62.4245 287.459C62.4245 301.206 61.4375 318.27 61.4375 318.27C74.6703 318.27 87.903 318.27 101.136 318.27C102.948 318.271 104.758 318.109 106.541 317.786C118.569 315.806 133.948 307.527 138.527 297.096Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M106.564 317.829C118.569 315.803 133.948 307.524 138.527 297.104C135.084 279.039 130.734 253.593 130.734 238.027C130.734 211.867 137.621 197.014 134.487 179.306C131.354 161.597 124.767 150.049 117.697 145.386C117.697 145.386 106.874 148.264 95.822 158.684C84.7698 169.104 75.049 187.02 71.2616 204.095C67.4743 221.17 62.4245 273.708 62.4245 287.456C62.4245 301.203 61.4375 318.267 61.4375 318.267C74.6703 318.267 87.903 318.267 101.136 318.267C102.955 318.284 104.772 318.138 106.564 317.829V317.829Z",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M117.057 149.462L136.039 184.142L137.061 203.163C137.061 203.163 142.352 189.599 139.999 180.745C137.646 171.891 117.057 149.462 117.057 149.462Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M137.049 203.175L131.758 283.438L137.645 299.96L141.766 266.904L138.231 200.803L137.049 203.175Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M131.839 116.962C131.839 116.962 132.505 125.609 133.17 129.823C133.836 134.037 123.449 145.827 123.449 145.827L138.473 168.659L155.493 155.36C155.493 155.36 179.594 153.587 181.786 151.584C183.978 149.58 184.001 127.646 184.001 127.646L189.739 124.319C189.739 124.319 184.437 101.291 183.117 96.156L181.786 91.0668C181.786 91.0668 189.521 88.3956 187.754 80.7043C185.987 73.013 174.716 69.1904 163.446 70.9405C152.176 72.6907 149.307 76.9278 149.307 76.9278C149.307 76.9278 133.388 76.709 124.333 84.2506C115.278 91.7922 120.798 103.755 123.667 107.969C126.109 111.213 128.845 114.223 131.839 116.962Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M158.487 147.931C154.069 142.508 158.487 121.806 161.93 111.455C165.373 101.104 157.018 96.6715 157.018 96.6715L182.107 92.3308L181.762 91.0297C183.459 90.3645 184.968 89.2933 186.158 87.9094L187.512 79.9073C185.217 72.6305 174.348 69.1303 163.411 70.8459C152.141 72.619 149.272 76.8331 149.272 76.8331C149.272 76.8331 133.353 76.6143 124.298 84.1559C115.243 91.6975 120.763 103.66 123.632 107.875C126.069 111.15 128.805 114.192 131.804 116.959C131.804 116.959 132.469 125.606 133.135 129.82C133.801 134.034 123.449 145.824 123.449 145.824L138.472 168.656L155.492 155.358C155.492 155.358 173.855 153.999 180.006 152.33L181.785 151.581C181.785 151.581 162.929 153.354 158.487 147.931Z",
    fill: "#605BFF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M158.487 147.931C154.069 142.508 158.487 121.806 161.93 111.455C165.373 101.104 157.018 96.6715 157.018 96.6715L182.107 92.3308L181.762 91.0297C183.459 90.3645 184.968 89.2933 186.158 87.9094L187.512 79.9073C185.217 72.6305 174.348 69.1303 163.411 70.8459C152.141 72.619 149.272 76.8331 149.272 76.8331C149.272 76.8331 133.353 76.6143 124.298 84.1559C115.243 91.6975 120.763 103.66 123.632 107.875C126.069 111.15 128.805 114.192 131.804 116.959C131.804 116.959 132.469 125.606 133.135 129.82C133.801 134.034 123.449 145.824 123.449 145.824L138.472 168.656L155.492 155.358C155.492 155.358 173.855 153.999 180.006 152.33L181.785 151.581C181.785 151.581 162.929 153.354 158.487 147.931Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M171.396 106.768C171.396 106.768 171.396 106.423 171.396 105.882C171.396 104.166 171.683 100.459 174.541 99.4455C178.294 98.1214 181.427 101.668 181.427 101.668L181.645 105.214C181.105 104.537 180.396 104.016 179.589 103.704C178.782 103.393 177.908 103.302 177.055 103.441C174.858 103.904 172.872 105.072 171.396 106.768Z",
    fill: "#666666"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M177.814 113.864C177.814 115.694 177.309 117.191 176.666 117.191C176.024 117.191 175.519 115.694 175.519 113.864C175.519 112.033 176.012 110.536 176.666 110.536C177.32 110.536 177.814 112.021 177.814 113.864Z",
    fill: "#666666"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M170.849 137.087C169.621 138.365 167.979 138.779 167.188 138.019C166.396 137.259 166.751 135.59 167.979 134.312C169.207 133.034 170.837 132.619 171.629 133.379C172.421 134.139 172.077 135.809 170.849 137.087Z",
    fill: "#666666"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M131.839 116.962C131.839 116.962 132.505 125.609 133.17 129.823C133.836 134.037 123.449 145.827 123.449 145.827L138.473 168.659L155.493 155.36C155.493 155.36 179.594 153.587 181.786 151.584C183.978 149.58 184.001 127.646 184.001 127.646L189.739 124.319C189.739 124.319 184.437 101.291 183.117 96.156L181.786 91.0668C181.786 91.0668 189.521 88.3956 187.754 80.7043C185.987 73.013 174.716 69.1904 163.446 70.9405C152.176 72.6907 149.307 76.9278 149.307 76.9278C149.307 76.9278 133.388 76.709 124.333 84.2506C115.278 91.7922 120.798 103.755 123.667 107.969C126.109 111.213 128.845 114.223 131.839 116.962V116.962Z",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M153.059 95.2343C157.041 92.5746 181.751 91.0317 181.751 91.0317C181.751 91.0317 189.486 88.3605 187.719 80.6692C185.951 72.9779 174.681 69.1553 163.411 70.9054C152.141 72.6555 149.272 76.8926 149.272 76.8926C149.272 76.8926 133.353 76.6739 124.298 84.2155C115.243 91.7571 120.763 103.72 123.632 107.934C126.069 111.21 128.805 114.251 131.804 117.019C131.804 117.019 132.171 121.762 132.63 125.942L139.516 127.888L147.034 123.892L154.551 122.119C154.551 122.119 149.019 117.905 152.118 113.921C155.217 109.938 160.955 108.602 161.173 105.493C161.391 102.384 149.076 97.894 153.059 95.2343Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M177.18 82.3486C177.18 82.3486 174.586 77.5819 179.338 78.4454C184.089 79.309 184.089 87.5529 180.199 89.28C176.308 91.0071 155.145 87.1154 143.473 90.5811C131.801 94.0468 123.606 103.58 123.606 103.58",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M130.093 110.951C130.093 110.951 139.171 103.157 146.505 101.855C153.838 100.554 157.74 100.554 149.534 105.31C141.329 110.065 146.941 109.201 152.128 107.474",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M149.077 128.048C149.077 128.048 147.757 114.081 140.906 113.644C134.054 113.206 134.272 123.177 136.315 130.051C138.358 136.925 143.201 139.136 147.138 135.589",
    fill: "#605BFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.077 128.048C149.077 128.048 147.757 114.081 140.906 113.644C134.054 113.206 134.272 123.177 136.315 130.051C138.358 136.925 143.201 139.136 147.138 135.589",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.077 128.048C149.077 128.048 147.757 114.081 140.906 113.644C134.054 113.206 134.272 123.177 136.315 130.051C138.358 136.925 143.201 139.136 147.138 135.589",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M149.077 128.048C149.077 128.048 147.757 114.081 140.906 113.644C134.054 113.206 134.272 123.177 136.315 130.051C138.358 136.925 143.201 139.136 147.138 135.589",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M124.058 137.36L146.162 171.062L135.994 184.141C131.414 175.278 126.325 166.69 120.753 158.419C113.235 147.78 112.352 146.007 112.352 146.007L124.058 137.36Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M124.058 137.36L112.352 146.007C112.352 146.007 113.006 147.308 117.826 154.251L130.198 146.721L124.058 137.36Z",
    fill: "#605BFF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.058 137.36L112.352 146.007C112.352 146.007 113.006 147.308 117.826 154.251L130.198 146.721L124.058 137.36Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M124.058 137.36L146.162 171.062L135.994 184.141C131.414 175.278 126.325 166.69 120.753 158.419C113.235 147.78 112.352 146.007 112.352 146.007L124.058 137.36Z",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M180.901 221.172C180.901 221.172 184.436 213.849 185.102 209.198C185.768 204.546 185.986 201.875 188.637 199.664C191.288 197.454 199.907 188.576 201.261 185.249C202.616 181.921 203.465 185.03 204.13 187.69C204.796 190.349 204.567 192.79 202.363 194.345C200.81 195.501 199.4 196.838 198.163 198.329L200.148 199.883C200.148 199.883 227.773 189.463 230.653 188.369C233.534 187.275 236.174 188.139 236.392 190.361C236.61 192.583 235.738 192.802 234.406 193.47C233.075 194.138 218.499 199.227 216.502 200.113L214.517 201L216.066 202.554C216.066 202.554 224.02 202.335 228.002 202.117C231.985 201.898 237.941 201.23 238.825 202.554C239.219 203.147 239.37 203.869 239.246 204.571C239.122 205.272 238.733 205.899 238.159 206.319C237.695 206.766 237.135 207.102 236.523 207.301C235.911 207.5 235.262 207.558 234.624 207.471C232.639 207.471 215.619 208.795 215.619 208.795L216.066 211.236C216.066 211.236 234.188 214.114 234.842 215.001C235.497 215.887 235.508 216.336 234.842 217.66C234.177 218.985 233.695 218.996 231.973 218.996C230.252 218.996 215.906 216.774 215.906 216.774C215.906 216.774 222.975 220.769 223.859 221.437C224.743 222.105 227.83 222.588 226.946 224.097C226.063 225.605 225.627 226.089 224.295 225.87C222.964 225.651 213.473 221.437 213.473 221.437C213.473 221.437 203.97 222.761 200.848 222.991C198.55 223.098 196.248 223.021 193.962 222.761L185.125 228.518L180.901 221.172Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M118.146 211.188C118.146 211.188 111.731 184.361 109.08 178.374C106.429 172.386 91.4054 166.86 84.1062 179.928C76.8069 192.996 83.4405 207.861 86.1031 218.499C88.7657 229.138 105.545 277.22 107.978 283.242C110.411 289.264 114.864 287.848 117.263 287.237C119.661 286.627 186.87 232.247 186.87 232.247L181.567 220.284L129.417 247.146L118.146 211.188Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M116.263 270.177C117.966 264.987 119.931 259.887 122.151 254.898C124.607 249.97 110.364 266.239 107.414 257.362C104.465 248.484 85.8035 204.133 89.2351 189.349C90.7236 182.48 94.7296 176.423 100.459 172.378C94.985 171.076 88.2825 172.458 84.105 179.942C76.8172 193.022 83.4393 207.875 86.1019 218.514C88.7645 229.153 105.544 277.235 107.977 283.256C110.41 289.278 114.863 287.862 117.261 287.252C119.029 286.768 155.135 257.834 174.646 242.14L116.263 270.177Z",
    fill: "#605BFF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M116.263 270.177C117.966 264.987 119.931 259.887 122.151 254.898C124.607 249.97 110.364 266.239 107.414 257.362C104.465 248.484 85.8035 204.133 89.2351 189.349C90.7236 182.48 94.7296 176.423 100.459 172.378C94.985 171.076 88.2825 172.458 84.105 179.942C76.8172 193.022 83.4393 207.875 86.1019 218.514C88.7645 229.153 105.544 277.235 107.977 283.256C110.41 289.278 114.863 287.862 117.261 287.252C119.029 286.768 155.135 257.834 174.646 242.14L116.263 270.177Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M118.146 211.188C118.146 211.188 111.731 184.361 109.08 178.374C106.429 172.386 91.4054 166.86 84.1062 179.928C76.8069 192.996 83.4405 207.861 86.1031 218.499C88.7657 229.138 105.545 277.22 107.978 283.242C110.411 289.264 114.864 287.848 117.263 287.237C119.661 286.627 186.87 232.247 186.87 232.247L181.567 220.284L129.417 247.146L118.146 211.188Z",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M173.835 224.72L179.803 236.913",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6426 163.547L3.11426 184.79C3.11426 184.79 18.1604 200.748 16.611 242.613C15.4633 274.587 19.6753 310.89 25.7924 318.271H58.2948C58.2948 318.271 47.059 256.096 47.8623 220.472C48.4936 193.402 40.3909 174.612 33.6426 163.547Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3135 163.547L6.78516 184.79C6.78516 184.79 21.8313 200.748 20.2704 242.613C19.1227 274.587 23.3347 310.89 29.4519 318.271H61.9657C61.9657 318.271 50.7413 256.096 51.5447 220.472C52.153 193.402 44.0504 174.612 37.3135 163.547Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6418 163.547H37.3144L6.78611 184.79H3.125L33.6418 163.547Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M175.654 368.86V370.354C176.122 370.318 176.698 370.282 177.31 370.282C178.318 370.282 182.512 370.282 183.52 370.282C184.024 370.282 184.654 370.318 185.194 370.354V368.86C184.672 368.914 184.024 368.95 183.52 368.95C182.512 368.95 178.318 368.95 177.274 368.95C176.698 368.95 176.158 368.914 175.654 368.86ZM173.512 373.378V374.872C173.998 374.836 174.538 374.818 175.078 374.818C176.122 374.818 185.896 374.818 186.85 374.818C187.3 374.818 187.876 374.836 188.272 374.872V373.378C187.822 373.432 187.228 373.468 186.85 373.468C185.896 373.468 176.122 373.468 175.078 373.468C174.52 373.468 173.998 373.432 173.512 373.378ZM181.99 374.098L180.478 374.116C180.46 376.096 180.334 377.86 179.434 379.282C178.714 380.434 177.418 381.46 176.032 382.054L177.364 383.026C178.894 382.252 180.244 380.956 180.91 379.75C181.702 378.238 181.99 376.366 181.99 374.098ZM186.13 367.384L185.176 367.798C185.662 368.482 186.274 369.562 186.616 370.282L187.588 369.85C187.228 369.13 186.58 368.032 186.13 367.384ZM188.092 366.664L187.156 367.078C187.66 367.744 188.254 368.77 188.65 369.544L189.604 369.112C189.262 368.446 188.578 367.33 188.092 366.664ZM191.818 374.206V375.97C192.394 375.934 193.348 375.898 194.338 375.898C195.67 375.898 202.852 375.898 204.22 375.898C205.012 375.898 205.768 375.952 206.146 375.97V374.206C205.732 374.242 205.102 374.314 204.202 374.314C202.87 374.314 195.652 374.314 194.338 374.314C193.312 374.314 192.376 374.26 191.818 374.206ZM215.47 373.756L214.48 374.764C216.712 376.15 219.79 378.364 221.446 379.876L222.508 378.616C220.726 377.176 217.774 375.106 215.47 373.756ZM223.696 370.48L222.508 369.76C222.22 369.868 221.824 369.922 221.338 369.922H215.614L215.038 371.218H221.698C221.284 372.892 220.15 375.178 218.764 376.834C217.144 378.76 214.696 380.668 211.348 381.676L212.626 382.81C216.046 381.55 218.386 379.624 220.024 377.608C221.608 375.664 222.742 373.27 223.282 371.434C223.372 371.146 223.552 370.732 223.696 370.48ZM217.63 367.87L215.992 367.348C215.884 367.816 215.596 368.464 215.416 368.77C214.588 370.426 212.734 373.126 209.656 375.052L210.844 375.97C213.724 373.99 215.758 371.272 216.82 369.292C217 368.95 217.324 368.338 217.63 367.87ZM227.728 370.66L227.836 372.01C228.502 372.028 229.276 372.046 229.942 372.046C232.138 372.064 234.496 371.668 236.26 371.182L236.224 369.85C234.154 370.534 231.886 370.768 229.942 370.768C229.168 370.768 228.394 370.732 227.728 370.66ZM234.118 367.726L232.534 367.564C232.48 368.824 232.084 370.408 231.688 371.542C230.95 373.666 229.276 376.87 227.674 378.742L229.06 379.462C230.554 377.446 232.21 374.17 233.074 371.578C233.506 370.3 233.884 368.608 234.118 367.726ZM238.366 373.288H236.944C237.016 375.268 237.214 378.49 237.214 379.858C237.214 380.83 236.71 381.622 235.216 381.622C233.812 381.622 233.11 381.046 233.11 380.218C233.11 379.39 234.01 378.778 235.342 378.778C237.988 378.778 240.058 380.38 241.444 381.64L242.2 380.416C240.724 379.138 238.402 377.626 235.378 377.626C233.362 377.626 231.796 378.67 231.796 380.326C231.796 382.126 233.398 382.918 235.378 382.918C237.61 382.918 238.528 381.748 238.528 380.308C238.528 379.12 238.366 376.384 238.33 375.214C238.312 374.566 238.312 374.026 238.366 373.288ZM241.966 373.756L242.776 372.568C241.912 371.92 239.878 370.75 238.564 370.192L237.844 371.272C239.032 371.83 240.994 372.928 241.966 373.756ZM250.12 367.978H248.284C248.392 368.5 248.446 369.13 248.446 369.796C248.446 371.686 248.266 376.24 248.266 378.904C248.266 381.856 250.048 382.918 252.64 382.918C256.582 382.918 258.922 380.668 260.146 378.958L259.138 377.734C257.842 379.606 255.97 381.442 252.676 381.442C250.966 381.442 249.724 380.758 249.724 378.778C249.724 376.096 249.868 371.83 249.94 369.796C249.976 369.202 250.03 368.572 250.12 367.978Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm014Nodata);
export default __webpack_public_path__ + "static/media/pm014_nodata.494e2fc5935a20ebe02c7ac53cbb1cd6.svg";
export { ForwardRef as ReactComponent };